import { render, staticRenderFns } from "./expertInventoryRegistration.vue?vue&type=template&id=1bd1a407&scoped=true&"
import script from "./expertInventoryRegistration.vue?vue&type=script&lang=js&"
export * from "./expertInventoryRegistration.vue?vue&type=script&lang=js&"
import style0 from "./expertInventoryRegistration.vue?vue&type=style&index=0&id=1bd1a407&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bd1a407",
  null
  
)

export default component.exports